const isPositiveInteger = (value) => {
  return typeof value === 'number' && value !== Infinity && isNaN(value) === false && value >= 0
}

/**
 * Converts numeric value of minutes to decimal representation.
 * If input is not a number return value is left as "-" intentionally for
 * backwards compatibility.
 * @example
 * // returns 2.08
 * minutesToDecimal(125)
 * @param {number} value Amount of minutes.
 * @returns {(number|string)} Decimal representation of hours.
 */
const minutesToDecimal = (value) => {
  if (isPositiveInteger(value)) {
    return parseFloat((value / 60).toFixed(2))
  }

  return '-'
}

module.exports = {
  minutesToDecimal
}
